import {ITrackerContext} from "@AppBuilderLib/shared/lib/TrackerContext.types";
import reportWebVitals from "reportWebVitals";

export const setupWebVitalsTracking = (tracker: ITrackerContext) => {
	reportWebVitals((r) => {
		const {name, value, rating} = r;
		tracker.trackMetric("Web vitals", name, value, {props: {rating}});
		console.debug("reportWebVitals", r);
	});
};
